/* jshint esversion: 8, node: true */
"use strict"
import { useFetch, type UseFetchOptions } from "nuxt/app"
async function sendContactFormToServer(email: string, content: string, backendUrl: string) {
  const requestOptions: UseFetchOptions<any> = {
    method: "POST",
    body: { email, content },
  }

  const { status } = await useFetch(backendUrl + "/contact", requestOptions)
  return status.value === "success"
}

async function sendStudyFormToServer(
  backendUrl: string,
  fullName: string,
  phoneNumber: string,
  furtherInfo: string | undefined
) {
  const requestOptions: UseFetchOptions<any> = {
    method: "POST",
    body: { fullName, phoneNumber, furtherInfo },
  }

  const { status } = await useFetch(backendUrl + "/study-patient", requestOptions)
  return status.value === "success"
}

export { sendContactFormToServer, sendStudyFormToServer }
